import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

type NavIcon = 'inbox' | 'network' | 'agentRuns';

interface NavItem {
  label: string;
  link: string;
  icon: NavIcon;
  exact?: boolean;
  comingSoon?: boolean;
}

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  // Built pages route to their features; comingSoon pages route to the placeholder page.
  readonly items: NavItem[] = [
    { label: 'Agent Cases', link: '/', icon: 'inbox', exact: true },
    { label: 'Network', link: '/network-dynamic', icon: 'network' },
    { label: 'Agent Runs', link: '/agent-runs', icon: 'agentRuns' },
  ];
}
